import { memo, useMemo } from 'react'
import { Button, Card, Text, Hidden, Flex, Skeleton } from '@backyard-ui/core'
import { useInstantSearch, useStats } from 'react-instantsearch'
import { FilterOutline } from '@backyard-ui/icons'

import { useEntryStore } from '../../Entry.store'
import { IS_ON_MOBILE_APP } from '../../constants'

interface HeaderProps {
  categoryTitle?: string | null
  contentType?: 'products' | 'services'
}

const Header = memo(
  ({ categoryTitle, contentType = 'products' }: HeaderProps) => {
    const { results, status } = useInstantSearch()
    const { nbHits } = useStats()

    const title = useMemo(() => {
      if (results?.query?.trim().length) {
        return results.query
      }
      return contentType === 'services'
        ? 'Serviços Recomendados'
        : 'Produtos Recomendados'
    }, [results?.query, contentType])

    const totalHits = useMemo(() => nbHits.toLocaleString(), [nbHits])
    const store = useEntryStore(state => state.ui)

    const isLoading = status === 'loading' || status === 'stalled'

    return (
      <Card.Root>
        <Card.Body>
          <Flex justify="space-between" align="center">
            {isLoading ? (
              <Skeleton width="250px" height="24px" />
            ) : IS_ON_MOBILE_APP ? (
              <div>
                <Text color="neutral-700">
                  <span className="font-bold">{categoryTitle || title}</span>
                </Text>
                <Text size="sm" color="neutral-700">
                  {`${totalHits} ${
                    totalHits === '1' ? 'Resultado' : 'Resultados'
                  }`}
                </Text>
              </div>
            ) : (
              <Text color="neutral-700">
                {`${totalHits} ${totalHits === '1' ? 'Resultado' : 'Resultados'}`}{' '}
                <Hidden below="lg">
                  para{' '}
                  <span className="capitalize font-bold">
                    {categoryTitle || title}
                  </span>
                </Hidden>
              </Text>
            )}

            <Hidden above="lg">
              <Button
                size="xs"
                iconLeft={<FilterOutline />}
                onClick={store.toggleFilters}>
                Filtros
              </Button>
            </Hidden>
          </Flex>
        </Card.Body>
      </Card.Root>
    )
  }
)

Header.displayName = 'Header'

export default Header
